<template>
  <div>
    <strong v-if="showLabel">Price: </strong>
    <span v-if="availability.will_not_sell">
      WNS
    </span>
    <span v-else-if="availability.sale">
      <span v-if="isValuePresent(availability.sale.asking_price) || isValuePresent(availability.sale.asking_price_sf)">
        <template v-if="showPrice">
          <Label
            :value="isValuePresent(availability.sale.asking_price) ? $filters.formatCurrencyNoDecimal(availability.sale.asking_price) : null"
          />
          <template v-if="showPsf">
            <Label
              v-if="availability.sale.type === 'perAcre'"
              :value="isValuePresent(availability.sale.asking_price_acre) ? `(${$filters.formatCurrency(availability.sale.asking_price_acre)} PPA)` : null"
            />
            <Label
              v-else
              :value="isValuePresent(availability.sale.asking_price_sf) ? `(${$filters.formatCurrency(availability.sale.asking_price_sf)} PSF)` : null"
            />
          </template>
        </template>
        <template v-else-if="showPsf">
          <Label
            v-if="availability.sale.type === 'perAcre'"
            :value="isValuePresent(availability.sale.asking_price_acre) ? `(${$filters.formatCurrency(availability.sale.asking_price_acre)} PPA)` : null"
          />
          <Label
            v-else
            :value="isValuePresent(availability.sale.asking_price_sf) ? `(${$filters.formatCurrency(availability.sale.asking_price_sf)} PSF)` : null"
          />
        </template>
        <v-tooltip v-if="availability.sale.private === true && !hideIcons" location="top">
          <template #activator="{ props }">
            <v-avatar
              color="red"
              size="16"
              v-bind="props"
              class="ml-1"
            >
              <span class="text-white text-caption">P</span>
            </v-avatar>
          </template>
          <span>The Sales Price is Private</span>
        </v-tooltip>
        <v-tooltip v-if="availability.sale.guidance_price === true && !hideIcons" location="top">
          <template #activator="{ props }">
            <v-avatar
              color="blue"
              size="16"
              class="ml-1"
              v-bind="props"
            >
              <span class="text-white text-caption">G</span>
            </v-avatar>
          </template>
          <span>The Sales Price is a guidance price</span>
        </v-tooltip>
      </span>
      <Label v-else />
    </span>
    <Label v-else />
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

import { IAvailability } from '@/bundles/Availabilities/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

import Label from '@/bundles/Common/components/Label.vue';

export default defineComponent({
  name: 'AvailabilitySalesPriceLabel',

  components: {
    Label
  },

  props: {
    availability: {
      type: Object as PropType<IAvailability>,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showPrice: {
      type: Boolean,
      default: true,
    },
    showPsf: {
      type: Boolean,
      default: true,
    },
    hideIcons: Boolean,
  },

  methods: {
    isValuePresent,
  }
})
</script>
